import React, { useState } from "react";
import "./style.css";
import { conversionFactorsO } from "./Data";
function App(props) {
  const [toUnit, setToUnit] = useState(props.unit);

  // const conversionFactorsO = {
  // 	'sq. ft.': {
  // 	  'sq. ft.' : 1,
  // 	  'sq. yards' : 0.111111,
  // 	  'sq. m.' : 0.092903 ,
  // 	  acres : 0.000023 ,
  // 	  hectares : 0.000009,
  // 	  bigha : 0.000092,
  // 	  marla : 0.003673 ,
  // 	  kanal : 0.000184 ,
  // 	},
  // 	'sq. yards': {
  // 	  'sq. ft.' : 9,
  // 	  'sq. yards' : 1,
  // 	  'sq. m.' : 0.836127  ,
  // 	  acres : 0.000207  ,
  // 	  hectares : 0.000084 ,
  // 	  bigha : 0.000826 ,
  // 	  marla : 0.033058  ,
  // 	  kanal : 0.001653  ,
  // 	},
  // 	'sq. m.': {
  // 	  'sq. ft.' : 10.763915 ,
  // 	  'sq. yards' : 1.19599,
  // 	  'sq. m.' : 1 ,
  // 	  acres : 0.000247  ,
  // 	  hectares : 0.000100 ,
  // 	  bigha : 0.000988 ,
  // 	  marla : 0.039537  ,
  // 	  kanal : 0.001977  ,
  // 	},
  // 	acres: {
  // 	  'sq. ft.' : 43560.057264 ,
  // 	  'sq. yards' : 4840.006363 ,
  // 	  'sq. m.' : 4046.860000  ,
  // 	  acres : 1 ,
  // 	  hectares : 0.404686 ,
  // 	  bigha : 4.000005 ,
  // 	  marla : 160.000210  ,
  // 	  kanal : 8.000011  ,
  // 	},
  // 	hectares: {
  // 	  'sq. ft.' : 107639.150512 ,
  // 	  'sq. yards' : 11959.905612 ,
  // 	  'sq. m.' : 10000.000000  ,
  // 	  acres : 2.471052  ,
  // 	  hectares : 1,
  // 	  bigha : 9.884220 ,
  // 	  marla : 395.368781  ,
  // 	  kanal : 19.768439  ,
  // 	},
  // 	bigha: {
  // 	  'sq. ft.' : 10890.000000 ,
  // 	  'sq. yards' : 1210.000000 ,
  // 	  'sq. m.' : 1011.713670  ,
  // 	  acres : 0.250000  ,
  // 	  hectares : 0.101171 ,
  // 	  bigha : 1,
  // 	  marla : 40.000000  ,
  // 	  kanal : 2.000000  ,
  // 	},
  // 	marla: {
  // 	  'sq. ft.' : 272.250000 ,
  // 	  'sq. yards' : 30.250000 ,
  // 	  'sq. m.' : 25.292842  ,
  // 	  acres : 0.002529   ,
  // 	  hectares : 0.000009,
  // 	  bigha : 0.025000 ,
  // 	  marla : 1 ,
  // 	  kanal : 0.050000  ,
  // 	},
  // 	kanal: {
  // 	  'sq. ft.' : 5445.000000 ,
  // 	  'sq. yards' : 605.000000 ,
  // 	  'sq. m.' : 505.856835  ,
  // 	  acres : 0.125000  ,
  // 	  hectares : 0.050586 ,
  // 	  bigha : 0.500000 ,
  // 	  marla : 20.000000  ,
  // 	  kanal : 1 ,
  // 	},

  // 	};
  //   const convertedResult =
  //   inputValue * conversionFactorsO[fromUnit][toUnit];
  //setResult(convertedResult.toFixed(4));

  const convertedResult = props.val * conversionFactorsO[props.unit][toUnit];
  return (
    <div className="main">
      <b>{convertedResult.toFixed(2)}</b>

      <select
        className="unit-selectors"
        value={toUnit}
        onChange={(e) => setToUnit(e.target.value)}
      >
        {Object.keys(conversionFactorsO[props.unit]).map((unit) => (
          <option key={unit} value={unit}>
            {unit}
          </option>
        ))}
      </select>
    </div>
  );
}

export default App;
